import { jsx as _jsx } from "react/jsx-runtime";

function SvgInsurer() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.9 1.075C9.918.311 11.132 0 12 0c.868 0 2.082.311 3.1 1.075C16.16 1.871 17 3.156 17 5c0 .957-.248 1.62-.594 2.234-.117.208-.254.425-.383.628l-.12.191c-.169.27-.339.555-.509.894-.36.722-.382 1.452-.122 2.333.236.803.69 1.681 1.297 2.72H18a4 4 0 014 4v1a2 2 0 01-2 2H4a2 2 0 01-2-2v-1a4 4 0 014-4h1.43c.609-1.039 1.062-1.917 1.298-2.72.26-.881.239-1.61-.122-2.333-.17-.34-.34-.624-.509-.894l-.12-.19v-.001c-.129-.204-.266-.42-.383-.628C7.248 6.62 7 5.957 7 5c0-1.844.84-3.13 1.9-3.925zM14.275 14c-.386-.726-.713-1.445-.922-2.155-.365-1.244-.386-2.514.253-3.792.21-.42.417-.765.6-1.06l.15-.237c.12-.19.217-.343.307-.503C14.878 5.87 15 5.543 15 5c0-1.156-.494-1.87-1.1-2.325C13.252 2.189 12.466 2 12 2c-.466 0-1.252.189-1.9.675C9.494 3.129 9 3.844 9 5c0 .543.122.871.337 1.253.09.16.187.314.307.503l.15.238c.184.294.39.64.6 1.059.64 1.278.618 2.548.253 3.792-.209.71-.536 1.429-.922 2.155h4.55zM4 18a2 2 0 012-2h12a2 2 0 012 2v1H4v-1zm1 4a1 1 0 100 2h14a1 1 0 100-2H5z"
    }, void 0)
  }), void 0);
}

export default SvgInsurer;